import { render, staticRenderFns } from "./AssignmentHistory.vue?vue&type=template&id=09ae86e8&scoped=true"
import script from "./AssignmentHistory.vue?vue&type=script&lang=js"
export * from "./AssignmentHistory.vue?vue&type=script&lang=js"
import style0 from "./AssignmentHistory.vue?vue&type=style&index=0&id=09ae86e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae86e8",
  null
  
)

export default component.exports